import styled from 'styled-components'
import { BoxDefault } from '../../components/BoxContainer/styles'
import IconUp from '../../assets/Icons/blueArrowUp.svg'
import IconDown from '../../assets/Icons/redArrowDown.svg'

export const Container = styled.div`
  ${BoxDefault} {
    margin-top: 0px !important;
  }

  header {
    h2 {
      font-weight: bold;
      font-size: var(--font-size-lg);
      color: var(--text-dark);
      margin: 0;
    }
    margin-bottom: 5px;
  }

  div {
    font-weight: lighter;
    font-size: var(--font-size-sm);
    color: var(--text-tertiary);
  }

  footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;

    strong {
      font-weight: bold;
      font-size: var(--font-size-lg);
      color: var(--theme-green);
    }

    div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      span {
        font-weight: lighter;
        font-size: var(--font-size-sm);
        color: var(--text-tertiary);
        display: inline-block;
      }
    }
  }
`

export const Icon = styled.i`
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-left: 8px;
  background: ${({ up }) =>
    up
      ? `transparent url(${IconUp}) no-repeat center center`
      : `transparent url(${IconDown}) no-repeat center center`};
`
